import Spacer from '@/common/components/spacer';
import WaitlistLink from '../waitlist-link';
import webpWithPngFallback from '@/common/utils/webp-with-png-fallback';

interface WaitlistTileProps {
  PUBLIC_CDN_URL: string;
  doesSupportWebp: boolean;
}
export default function WaitlistTile({
  PUBLIC_CDN_URL,
  doesSupportWebp,
}: WaitlistTileProps) {
  const imageUrl = webpWithPngFallback(
    `${PUBLIC_CDN_URL}/web/images/marketing-tiles/waitlist-card-2x.webp`,
    doesSupportWebp
  );

  return (
    <WaitlistLink
      className="relative flex aspect-square h-full w-full flex-1 cursor-pointer flex-col items-center justify-end rounded-[16px] bg-black bg-[length:100%_auto] bg-[center_top_-85px] bg-no-repeat p-[24px] transition-shadow hover:shadow-shadow30 min-[350px]:bg-[length:117%_auto] min-[350px]:bg-[center_top_-112px] min-[640px]:bg-[length:117%_auto] min-[640px]:bg-[center_top_-60px] min-[800px]:bg-[length:117%_auto] min-[800px]:bg-[center_top_-80px] min-[1024px]:bg-[length:117%_auto] min-[1024px]:bg-[center_top_-50px] min-[1180px]:bg-[length:117%_auto] min-[1180px]:bg-[center_top_-65px] min-[1364px]:bg-[length:116%_auto] min-[1364px]:bg-[center_top_-50px]"
      style={{ backgroundImage: `url(${imageUrl})` }}
      preventScrollReset={true}
    >
      <p className="body-strong w-full text-left text-flexcar-neutral80">
        Looking for a specific car?
      </p>
      <Spacer variant="height8" />
      <p className="w-full text-left text-flexcar-neutral80">
        Don&apos;t miss out—get notified as soon as it&apos;s available!
      </p>
      <Spacer variant="height28" />
      <p className="body-strong w-full text-right text-flexcar-neutral80">
        Get notified {'->'}
      </p>
    </WaitlistLink>
  );
}
